/*
          o
          v
        start
       __| |__
      |       |
      v       v
     snap    cancel
      |       |
      v       |
     move <-- |
      | |___| |
      v       |
     stop     |
      |__   __|
         | |
         v v
        reset
          v
          o
*/

function isTouchEvent(event) {
  return event.type.startsWith('touch')
}

function addEvents(element, events, useCapture) {
  for (const name in events) element.addEventListener(name, events[name], useCapture)
  return () => {
    for (const name in events) element.removeEventListener(name, events[name], useCapture)
  }
}

function get(state, property, fallback) {
  return state.scenario[property] !== undefined ? state.scenario[property] : fallback
}

function call(state, method, argument) {
  return typeof state.scenario[method] === 'function' ? state.scenario[method](argument) : undefined
}

function onStart(start, event) {
  // This cover left click and touch
  if ((event.which || event.button || 0) >= 2) return

  const scenario = start(event)
  if (scenario) {
    const state = {
      scenario,
      snapped: false,
      startOrigin: {
        x: event.pageX,
        y: event.pageY,
      },
    }
    state.removeGlobalEvents = addEvents(
      document,
      {
        touchmove: onMove.bind(null, state),
        mousemove: onMove.bind(null, state),
        touchend: onStop.bind(null, state),
        mouseup: onStop.bind(null, state),
        touchcancel: onStop.bind(null, state),
      },
      true,
    )
  }
}

function onMove(state, event) {
  if (!state.snapped) {
    const snapDistance = isTouchEvent(event)
      ? get(state, 'touchSnap', 20)
      : get(state, 'mouseSnap', 10)

    const distance =
      ((event.pageX - state.startOrigin.x) ** 2 + (event.pageY - state.startOrigin.y) ** 2) ** 0.5

    if (!snapDistance || distance > snapDistance) {
      state.snapped = true
      call(state, 'snap', event)
    }
  }

  if (state.snapped) {
    event.preventDefault()
    call(state, 'move', event)
  }
}

function onStop(state, event) {
  if (state.snapped) {
    event.stopPropagation()
    event.preventDefault()
    call(state, 'stop', event)
    setTimeout(
      addEvents(
        document,
        {
          click(event) {
            event.stopPropagation()
          },
        },
        true,
      ),
    )
  } else {
    call(state, 'cancel', event)
  }

  call(state, 'reset', event)
  state.removeGlobalEvents()
}

const boundValues = new WeakMap()

function bind(el, startCallback) {
  const removeEvents = addEvents(el, {
    touchstart: onStart.bind(null, startCallback),
    mousedown: onStart.bind(null, startCallback),
  })
  boundValues.set(el, removeEvents)
}

function unbind(el) {
  const removeEvents = boundValues.get(el)
  if (removeEvents) removeEvents()
}

export default {
  name: 'draggable',

  bind(el, binding) {
    if (binding.value) bind(el, binding.value)
  },

  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      unbind(el)
      if (binding.value) bind(el, binding.value)
    }
  },

  unbind(el) {
    unbind(el)
  },
}
